export default "/assets/images/easy-replacement.png?672793e7566700987adf7c83f957e787";